import React, { Component } from 'react';
import { getApiUrl, getRequestHeaders } from 'utils/api';
import { navigateToAccessDenied } from '@alixpartners/ui-components';
import { acquireToken } from '@alixpartners/ui-utils';
import { handleApiError } from 'components/ApiErrorNotification';
import { isDemoMode, updateUrlToDemoMode } from 'utils/apiRequests';

const defaultOpts = {
	mock: false,
	name: 'mutate',
	method: 'POST',
};

const withMutation = (resource, opts) => WrappedComponent =>
	class WithMutation extends Component {
		opts = { ...defaultOpts, ...opts };

		render() {
			const mutationProp = { [this.opts.name]: this.handleMutation };
			return <WrappedComponent {...this.props} {...mutationProp} />;
		}

		handleMutation = (body = {}) => {
			const url = this.getUrl();

			return new Promise((resolve, reject) => {
				acquireToken().then(token => {
					const headers = getRequestHeaders(token);
					const mergedHeaders = { ...headers, ...this.opts.headers };

					return fetch(url, {
						...this.opts,
						headers: mergedHeaders,
						body: JSON.stringify(body),
					})
						.then(response => {
							if (!response.ok) {
								return response.text().then(textResponse => {
									try {
										const jsonResponse = JSON.parse(textResponse);
										return Promise.reject({ ...jsonResponse, response });
									} catch (_e) {
										return Promise.reject(textResponse);
									}
								});
							}

							return resolve(response);
						})
						.catch(e => {
							if (isDemoMode) {
								handleApiError(url, true);
							}

							if (e.response) {
								if (e.response.status === 500) {
									handleApiError(e.correlationId);

									return;
								}

								if (e.response.status === 403) {
									navigateToAccessDenied(e.aadUrl, e.aadName);
								}
							}

							throw e;
						});
				});
			});
		};

		getUrl = () => {
			let resourceString = resource;

			if (typeof resource === 'function') {
				resourceString = resource(this.props);
			}

			return updateUrlToDemoMode(getApiUrl(resourceString, this.opts.mock));
		};
	};

export default withMutation;
